import React from 'react';
import { IoMdHeartEmpty } from 'react-icons/io';
import { FcLike } from 'react-icons/fc';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';
import CustomPagination from '../../../../../component/Pagination/CustomPagination';
import Video_title from '../../../../../component/Video_title';
import Card from '../../../../../component/Card';
import VideoThumbnailCard from '../../../../components/VideoThumbnailCard';

const VideoGrid = ({
	category,
	isLoggedIn,
	handlePlayerVideo,
	handleLikeVideo,
	handleSubmitPlaylist,
	selectedTags,
	setSelectedTags,
	savedVideoIds,
	totvideos,
	currentPage,
	handlePageChange,
	modal,
	setModal,
	setVideoData,
	selectTagCallback
}) => {
	return (
		<div style={{ display: 'flex', flexDirection: 'column' }} className="c-video_list">
			<div className="row m-0">
				{category?.videos?.map((video, index) => (
					<div key={index} className="mb-2">
						<VideoThumbnailCard
							key={index}
							content={video}
							isLoggedIn={isLoggedIn}
							handlePlayerVideo={handlePlayerVideo}
							handelSubmitPlaylist={handleSubmitPlaylist}
							handleSaveUnsave={handleLikeVideo}
							savedVideos={savedVideoIds}
							modal={modal}
							setModal={setModal}
							setVideoData={setVideoData}
							titleStyles={{ fontSize: 'clamp(1.15rem, 1.2vw, 1.6rem)' }}
							selectTagCallback={selectTagCallback}
							selectedTags={selectedTags}
						/>
					</div>
				))}
			</div>

			<CustomPagination totalPages={totvideos} currentPage={currentPage} onPageChange={handlePageChange} />
		</div>
	);
};

export default VideoGrid;
